import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from 'reactstrap';
import Navigation from '../../components/Navigation/Navigation';
import OccupationFields from '../../components/Fields/OccupationFields';
import { OccupationValidator } from '../../utils/Validators';
import withBackgroundImage from '../../HOC/withBackgroundImage';
import debounce from 'debounce';

import TagManager from 'react-gtm-module'

import { updateOccupation } from '../../actions/occupationAction';

const tagManagerArgs = {
  dataLayer: {
      pageCategory: 'Occupation',
      event: 'Credit Card Step 3'
  }
}

class Occupation extends Component {
  constructor(props) {
    super(props);

    this.validator = OccupationValidator(this.props.status || "Employed");

    this.state = {
      status: this.props.status || "Employed",
      industry: this.props.industry || "",
      occupationName: this.props.occupationName || "",
      noc: this.props.noc || "",
      employer: this.props.employer || "",
      employedSince: this.props.employedSince || "",
      phone: this.props.phone || "",
      validation: this.validator.valid()
    };

    this.onClickForward = this.onClickForward.bind(this);
    this.onClickBackward = this.onClickBackward.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.validateField = this.validateField.bind(this);
  }

  componentDidMount() {
    TagManager.dataLayer(tagManagerArgs)
  }

  onClickForward(event) {
    event.preventDefault();
    let validation = (this.state.status === "Employed" || this.state.status === "SelfEmployed") ? this.validator.validate(this.state) : this.validator.valid();
    this.setState({validation: validation}, () => {
      if(this.state.validation.isValid) {
        if(this.state.status !== "Employed" && this.state.status !== "SelfEmployed") {
          this.props.updateOccupation({status: this.state.status, industry: "", occupationName: "", noc: this.state.noc, employer: "", employedSince: "", phone: ""});
        }
        else {
          this.props.updateOccupation({...this.state});
        }
        this.props.history.replace('/IncomeExpenses');
      }
    });
  }
  onClickBackward() {
    this.props.history.replace('/PersonalInfo/LivingSituation');
  }
  handleChange(event) {
    // If the field is a datepicker, validate it on change, instead of just resetting the validation
    if(event.target.name === "employedSince") {
      this.setState({
        validation: {...this.state.validation, [event.target.name]: this.validator.validateField(event.target.name, event.target.value)},
        [event.target.name]: event.target.value
      },() => {
        this.updateOccupation();
      });
    }
    else if(event.target.name === "status") {
      this.setState({
        validation: {...this.state.validation, [event.target.name]: this.validator.resetFieldValidation(event.target.name)},
        ...event.target.value
      }, () => {
        this.valid = OccupationValidator(this.state.status);
        this.updateOccupation();
      });
    }
    else if(event.target.name === "industry") {
      this.setState({
        validation: {...this.state.validation, [event.target.name]: this.validator.resetFieldValidation(event.target.name), occupationName: this.validator.resetFieldValidation("occupationName")},
        [event.target.name]: event.target.value,
        occupationName: "",
        noc: ""
      }, () => {
        this.updateOccupation();
      });
    }
    else if(event.target.name === "occupationName") {
      this.setState({
        validation: {...this.state.validation, [event.target.name]: this.validator.resetFieldValidation(event.target.name)},
        ...event.target.value
      }, () => {
        this.updateOccupation();
      });
    }
    else {
      this.setState({
        validation: {...this.state.validation, [event.target.name]: this.validator.resetFieldValidation(event.target.name)},
        [event.target.name]: event.target.value
      }, () => {
        this.updateOccupation();
      });
    }
  }
  validateField(event) {
    this.setState({
      validation: {...this.state.validation, [event.target.name]: this.validator.validateField(event.target.name, event.target.value)}
    });
  }
  updateOccupation = debounce(() => {
    this.props.updateOccupation({...this.state});
  }, 1000);
  render() {
    return (
      <div>
        <h1>Tell us about your work</h1>
        <Form onSubmit={this.onClickForward}>
          <OccupationFields handleChange={this.handleChange} validateField={this.validateField} {...this.state} />
          <Navigation onClickForward={this.onClickForward} onClickBackward={this.onClickBackward} />
        </Form>
      </div>);
  }
}

const mapStateToProps = state => ({
  ...state.occupation
});

const mapDispatchToProps = dispatch => ({
  updateOccupation: (occupationInfo) => dispatch(updateOccupation(occupationInfo))
});


export default connect(mapStateToProps, mapDispatchToProps)(withBackgroundImage("occupation")(Occupation));


// WEBPACK FOOTER //
// ./src/containers/Occupation/Occupation.js